export default "__VITE_ASSET__COb3eufr__"